import { Middleware } from "../middleware"
export default{


   
    getStatusLokiFinding () {
        return new Middleware()
            .method('GET')
            .append('/loki/status-list/findings')
            .build()
    },
  
  
    getDetailsAll (id,clientId,filter,origin,type='') {
        origin = origin === 'channels' ? 'commschannels' : origin
        const url = origin !== 'axur' ? `/loki/${origin}-findings/all` : `/loki/axur/${type}/all/${id}`
        return new Middleware()
            .method('GET')
            .append(url)
            .params({
                monitoringId: origin === 'commschannels' || origin === 'axur' ? undefined: id,
                channelId:origin === 'commschannels' ? id : undefined,
                idCompany:clientId === 'undefined' ? undefined : clientId,
                search: filter.search,
                page: filter.page,
                size: filter.size,
                startDate: filter.startDate,
                endDate: filter.endDate,
                status:filter.status,
                origin: filter.origin
            })
            .build()
    },

    getDonutDetails (id,clientId,origin,type='') {
        origin = origin === 'channels' ? 'commschannels' : origin
        const url = origin !== 'axur' ? `/loki/${origin}-findings/donut-chart` : `/loki/axur/${type}/donut-chart`
        return new Middleware()
            .method('GET')
            .append(url)
            .params({
               id,
                idCompany:clientId === 'undefined' ? undefined : clientId,
            })
            .build()
    },
    getLineChartDetails (id,clientId, origin,type='') {
        origin = origin === 'channels' ? 'commschannels' : origin
        const url = origin !== 'axur' ? `/loki/${origin}-findings/line-chart` : `/loki/axur/${type}/line-chart`
        return new Middleware()
            .method('GET')
            .append(url)
            .params({
                id:id,
                idCompany:clientId === 'undefined' ? undefined : clientId,
            })
            .build()
    },

    changeStatusDetails(id, payload, origin,type = '', idAxur = ''){
        const originInternal = origin !== 'channels' ? origin : 'commschannels'
        let url = ''
        if(type === ''){
                url  = `/loki/${originInternal}-findings/${id}`
                // if(id !== undefined){
                //     url = url.concat(`${id}`)
                // }
        }else{
            url = `/loki/axur/${type}/${idAxur}`
        }
        
        return new Middleware()
        .method('PUT')
        .append(url)
        .setData(payload)
        .build()
    },

    getOriginList(id,route){
        return new Middleware()
        .method('GET')
        .append(`/loki/${route}-findings/origin-list/${id}`)
        .build()
    },


}